import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const PanelReliableCustomerService = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-lg-5 py-m'>
            <Row className='reverse-section pt-lg-4'>
                <Col md='12' lg='6' className=''>
                    <div className='flex-center'>
                        <img className='img-w13' src='panel-testing/ULC-Services-img1.webp' alt='ULC Services' height='auto' width='' />
                    </div>
                </Col>
                <Col md='12' lg='6' className='ps-lg-0 me-md-'>
                    <div className='py-4 pt-md-0'>
                        <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                            RELIABLE CUSTOMER SERVICE
                        </div>
                        <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

                        <div className='py-4'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            United Lab Care offers COVID-19, RSV, Flu, and Respiratory Pathogen Panel testing. Because our team of experts is always ready to provide authentic lab testing services in Chicago. We are committed to maintaining and achieving a high standard of quality and service in all aspects of our laboratory testing.
                            </div>
                        </div>

                        <div className='flex-center1'>
                        <Link to='/book-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                                    SCHEDULE YOUR PANEL TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default PanelReliableCustomerService